import { useState } from "react";
import { DomainService } from "../../application/services/domainNameService";

const domainService = new DomainService();

export const useDomain = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [vms, setVms] = useState(null);

  const getAllVmsWithPublicIp = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await domainService.getAllVmsWithPublicIp();
      if (result.success) {
        setVms(result.vms);
        return { success: true, vms: result.vms };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const updateVmDomainName = async (vmId, domainName) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await domainService.updateVmDomainName(vmId, domainName);
      if (result.success) {
        setSuccessMessage(result.message);
        return { success: true, message: result.message };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

   const updateVmBillingType = async (vmId, billingType) => {
        setLoading(true);
        setError(null);
        setSuccessMessage(null);
        try {
            const result = await domainService.updateVmBillingType(vmId, billingType);
            if (result.success) {
                setSuccessMessage(result.message);
                return { success: true, message: result.message };
            } else {
                setError(result.message);
                return { success: false, message: result.message };
            }
        } catch (error) {
            setError(error.message);
            return { success: false, message: error.message };
        } finally {
            setLoading(false);
        }
    };

  return {
    getAllVmsWithPublicIp,
    updateVmDomainName,
    updateVmBillingType,
    vms,
    loading,
    error,
    successMessage,
  };
};